import React from "react";
import DocumentUploadField from "../elements/document-upload-field";

export default function HospitalInvoice(props: any) {
  return (
    <DocumentUploadField
      title="Hospital Invoice"
      onUploaded={props.setHospitalInvoice}
    />
  );
}
